// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCentraLignNotRunning_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 9V5H11V9H15V11H11V15H9V11H5V9H9ZM32 32V25H34V32H41V34H34V41H32V34H25V32H32Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7429 16.3288C19.1536 14.6049 20 12.4013 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C12.4012 20 14.6048 19.1537 16.3286 17.743L21.7097 23.124C19.3998 25.7625 18 29.2178 18 33C18 41.2843 24.7157 48 33 48C41.2843 48 48 41.2843 48 33C48 24.7157 41.2843 18 33 18C29.2177 18 25.7624 19.3999 23.1239 21.7098L17.7429 16.3288ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM33 46C40.1797 46 46 40.1797 46 33C46 25.8203 40.1797 20 33 20C25.8203 20 20 25.8203 20 33C20 40.1797 25.8203 46 33 46Z" class="svg-bg"/>
  <circle cx="43" cy="5" r="5" fill="#FDCA40"/>
</svg>
`;
/**
 * IconMedCentraLignNotRunning is a generated icon component.
 */
let IconMedCentraLignNotRunning = IconMedCentraLignNotRunning_1 = class IconMedCentraLignNotRunning extends IconBaseElement {
    render() {
        return html `${IconMedCentraLignNotRunning_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCentraLignNotRunning.icons = new Map([
    ['s8', _s48IconSvg],
    ['s12', _s48IconSvg],
    ['s16', _s48IconSvg],
    ['s24', _s48IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconMedCentraLignNotRunning = IconMedCentraLignNotRunning_1 = __decorate([
    customElement('zui-icon-med-centra-lign-not-running')
], IconMedCentraLignNotRunning);
export { IconMedCentraLignNotRunning };
